export const GET_OPSGENIE_TEAMS = "GET_OPSGENIE_TEAMS";
export const GET_OPSGENIE_TEAMS_SUCCESS = "GET_OPSGENIE_TEAMS_SUCCESS";
export const GET_OPSGENIE_TEAMS_FAIL = "GET_OPSGENIE_TEAMS_FAIL";

export const GET_REFRESH_OPSGENIE = "GET_REFRESH_OPSGENIE";
export const GET_REFRESH_OPSGENIE_SUCCESS = "GET_REFRESH_OPSGENIE_SUCCESS";
export const GET_REFRESH_OPSGENIE_FAIL = "GET_REFRESH_OPSGENIE_FAIL";